'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = function (Child) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    (0, _inherits3.default)(Debounce, _React$Component);

    function Debounce(props) {
      (0, _classCallCheck3.default)(this, Debounce);

      var _this = (0, _possibleConstructorReturn3.default)(this, (Debounce.__proto__ || Object.getPrototypeOf(Debounce)).call(this, props));

      _this.deboucedDidRecieveProps = (0, _debounce2.default)(_this.didRecieveProps, 100);
      _this.state = { props: props };
      return _this;
    }

    (0, _createClass3.default)(Debounce, [{
      key: 'didRecieveProps',
      value: function didRecieveProps(props) {
        this.setState({ props: props, debouncing: false });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if ((0, _isEqual2.default)(nextProps.variables, this.props.variables)) {
          this.didRecieveProps(nextProps);
        } else {
          this.setState({ debouncing: true });
          this.deboucedDidRecieveProps(nextProps);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Child, (0, _extends3.default)({ ref: 'child', debouncing: this.state.debouncing }, this.state.props));
      }
    }]);
    return Debounce;
  }(_react2.default.Component), _class.propTypes = {
    variables: _propTypes2.default.object
  }, _temp;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/lib/debounce.js
// module id = 1553
// module chunks = 83